import React, { useRef } from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';

import Toast from '@base/Toast';
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';
import { VisualizarCartao, ReetiquetarCartao } from '@base/CartaoUtils/CartaoUtils';

const PaperCompararCartoesNomeDuplicado = ({
  processo,
  blob,
  cartao,
  cartoes,
  onCartoesUpdate,
  listagemStatus,
  isPodeUsarAcoes = true,
  children,
}) => {
  const toastRef = useRef(null);

  const getStatus = (status) => listagemStatus?.find(st => st.value === status)?.label ?? status;

  return (
    <Paper
      elevation={3}
      style={{
        marginTop: 10,
        padding: 5,
      }}
    >
      <Toast ref={toastRef} />

      <Grid container>
        
        <Grid item lg={isPodeUsarAcoes ? 10 : 12}>
          <Table size="small">
            <TableBody>

              <TableRow>
                <TableCell align="right"><b>Código</b></TableCell>
                <TableCell>{cartao.codigo}</TableCell>
                <TableCell align="right"><b>Código Original</b></TableCell>
                <TableCell>{cartao.codigoOriginal}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell align="right"><b>Objeto Postal</b></TableCell>
                <TableCell>{cartao.numeroObjetoPostal}</TableCell>
                <TableCell align="right"><b>INEP</b></TableCell>
                <TableCell>{cartao.codigoInep}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell align="right"><b>Origem</b></TableCell>
                <TableCell>{cartao.origem?.descricao}</TableCell>
                <TableCell align="right"><b>Status</b></TableCell>
                <TableCell>{getStatus(cartao.status)}</TableCell>
              </TableRow>

            </TableBody>
          </Table>
        </Grid>

        {isPodeUsarAcoes && (
          <Grid item lg={2} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
            <VisualizarCartao cartao={cartao} processo={processo} aoFechar={onCartoesUpdate} />
            <ReetiquetarCartao cartao={cartao} processo={processo} aoFechar={onCartoesUpdate} />
          </Grid>
        )}
      </Grid>     

      <Grid container>
        <Grid item lg={12}>
          {cartao.nomeArquivo == null ? (
            <Alert severity="warning">Sem imagem</Alert>
          ) : (
            <VisualizadorDeArquivo blob={blob} />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PaperCompararCartoesNomeDuplicado;
